/**
 * 配色設定CSS
 */
export const COLOR_CSS = 'COLOR_CSS';

/**
 * favicon
 */
export const FAVICON = 'FAVICON';

/**
 * ナビゲーションロゴ
 */
export const NAV_LOGO = 'NAV_LOGO';

/**
 * プライバシーマーク画像
 */
export const PRIVACY_MARK = 'PRIVACY_MARK';

/**
 * 試験終了画像
 */
export const EXAM_END_IMG = 'EXAM_END_IMG';

/**
 * 結果画面 レーダーチャートタイトル
 */
export const CHART_TITLE = 'CHART_TITLE';

/**
 * 再挑戦画像
 */
export const EXAM_RETRY_IMG = 'EXAM_RETRY_IMG';

/**
 * コピーライト
 */
export const COPY_RIGHT = 'COPY_RIGHT';

// ----------------------------------- //

/**
 * TOP メインビジュアル画像
 */
export const TOP_MV_PIC = 'TOP_MV_PIC';

/**
 * TOP メインビジュアル画像(SP)
 */
export const TOP_MV_PIC_SP = 'TOP_MV_PIC_SP';

/**
 * TOP メインビジュアルロゴ
 */
export const TOP_MV_LOGO = 'TOP_MV_LOGO';

/**
 * TOP メインビジュアル背景
 */
export const TOP_MV_BG = 'TOP_MV_BG';

/**
 * TOP メインビジュアル タイトル
 */
export const TOP_MV_TITLE = 'TOP_MV_TITLE';

/**
 * TOP メインビジュアル サブタイトル
 */
export const TOP_MV_SUB_TITLE = 'TOP_MV_SUB_TITLE';

/**
 * TOP メインビジュアル タイトル受験期間
 */
export const TOP_MV_TITLE_TERM = 'TOP_MV_TITLE_TERM';


// ----------------------------------- //

/**
 * お知らせ アイコン
 */
export const NEWS_ICON = 'NEWS_ICON';

/**
 * お知らせ 行頭アイコン
 */
export const NEWS_ROW_HEAD_ICON = 'NEWS_ROW_HEAD_ICON';

/**
 * お知らせ メイン文字色（タイトル、本文）
 */
export const NEWS_MAIN_COLOR = 'NEWS_MAIN_COLOR';

/**
 * お知らせ サブタイトル文字色
 */
export const NEWS_SUB_TITLE_COLOR = 'NEWS_SUB_TITLE_COLOR';

// ----------------------------------- //

/**
 * 検定一覧 アイコン
 */
export const ENTRY_ICON = 'ENTRY_ICON';

/**
 * TOP 検定一覧 背景
 */
export const TOP_ENTRY_BG = 'TOP_ENTRY_BG';

/**
 * TOP 検定一覧 メイン文字色（タイトル、本文）
 */
export const TOP_ENTRY_MAIN_COLOR = 'TOP_ENTRY_MAIN_COLOR';

/**
 * TOP 検定一覧 サブタイトル文字色
 */
export const TOP_ENTRY_SUB_TITLE_COLOR = 'TOP_ENTRY_SUB_TITLE_COLOR';

/**
 * 会員登録完了 検定一覧 背景
 */
export const ACCOUNT_ENTRY_BG = 'ACCOUNT_ENTRY_BG';

/**
 * 会員登録完了 検定一覧 メイン文字色（タイトル、本文）
 */
export const ACCOUNT_ENTRY_MAIN_COLOR = 'ACCOUNT_ENTRY_MAIN_COLOR';

/**
 * 会員登録完了 検定一覧 サブタイトル文字色
 */
export const ACCOUNT_ENTRY_SUB_TITLE_COLOR = 'ACCOUNT_ENTRY_SUB_TITLE_COLOR';

// ----------------------------------- //

/**
 * 検定説明 アイコン
 */
export const ABOUT_ICON = 'ABOUT_ICON';

/**
 * 検定説明 メイン文字色（タイトル、本文）
 */
export const ABOUT_MAIN_COLOR = 'ABOUT_MAIN_COLOR';

/**
 * 検定説明 サブタイトル文字色
 */
export const ABOUT_SUB_TITLE_COLOR = 'ABOUT_SUB_TITLE_COLOR';

// ----------------------------------- //

/**
 * 特典紹介 アイコン
 */
export const BENEFITS_ICON = 'BENEFITS_ICON';

/**
 * 特典サムネイル表示場所キー
 */
export const RANK_BENEFIT_THUMBNAIL = 'RANK_BENEFIT_THUMBNAIL';

/**
 * TOP 特典紹介 背景
 */
export const TOP_BENEFITS_BG = 'TOP_BENEFITS_BG';

/**
 * TOP 特典紹介 メイン文字色（タイトル、本文）
 */
export const TOP_BENEFITS_MAIN_COLOR = 'TOP_BENEFITS_MAIN_COLOR';

/**
 * TOP 特典紹介 サブタイトル文字色
 */
export const TOP_BENEFITS_SUB_TITLE_COLOR = 'TOP_BENEFITS_SUB_TITLE_COLOR';

/**
 * 検定詳細 特典紹介 背景
 */
export const EXAM_DETAIL_BENEFITS_BG = 'EXAM_DETAIL_BENEFITS_BG';

/**
 * 検定詳細 特典紹介 メイン文字色（タイトル、本文）
 */
export const EXAM_DETAIL_BENEFITS_MAIN_COLOR = 'EXAM_DETAIL_BENEFITS_MAIN_COLOR';

/**
 * 検定詳細 特典紹介 サブタイトル文字色
 */
export const EXAM_DETAIL_BENEFITS_SUB_TITLE_COLOR = 'EXAM_DETAIL_BENEFITS_SUB_TITLE_COLOR';

/**
 * 受験結果 特典紹介 背景
 */
export const RESULT_BENEFITS_BG = 'RESULT_BENEFITS_BG';

/**
 * 受験結果 特典紹介 メイン文字色（タイトル、本文）
 */
export const RESULT_BENEFITS_MAIN_COLOR = 'RESULT_BENEFITS_MAIN_COLOR';

/**
 * 受験結果 特典紹介 サブタイトル文字色
 */
export const RESULT_BENEFITS_SUB_TITLE_COLOR = 'RESULT_BENEFITS_SUB_TITLE_COLOR';

/**
 * 受験結果 正答率 背景色
 */
export const ANSWER_RATE_RESULT_BG = 'ANSWER_RATE_RESULT_BG';

/**
 * 受験結果 カテゴリ別正解率 タイトル背景色
 */
export const CHART_TITLE_CATEGORY_BG = 'CHART_TITLE_CATEGORY_BG';

/**
 * 受験結果 評価基準別正解率 タイトル背景色
 */
export const CHART_TITLE_EVALUATION_BG = 'CHART_TITLE_EVALUATION_BG';

/**
 * 受験者全員特典 バッヂ設定
 */
export const BENEFITS_BADGE_ALL = 'BENEFITS_BADGE_ALL';

/**
 * 合格者特典 バッヂ設定
 */
export const BENEFITS_BADGE_PASS = 'BENEFITS_BADGE_PASS';

/**
 * 満点合格者特典 バッヂ設定
 */
export const BENEFITS_BADGE_PERFECT = 'BENEFITS_BADGE_PERFECT';

// ----------------------------------- //

/**
 * 検定概要 アイコン
 */
export const TOP_OUTLINE_ICON = 'TOP_OUTLINE_ICON';

/**
 * 検定概要 メイン文字色（タイトル、本文）
 */
export const TOP_OUTLINE_MAIN_COLOR = 'TOP_OUTLINE_MAIN_COLOR';

/**
 * 検定概要 サブタイトル文字色
 */
export const TOP_OUTLINE_SUB_TITLE_COLOR = 'TOP_OUTLINE_SUB_TITLE_COLOR';

// ----------------------------------- //

/**
 * 受験の流れ アイコン
 */
export const TOP_STEP_ICON = 'TOP_STEP_ICON';

/**
 * 受験の流れ 背景
 */
export const TOP_STEP_BG = 'TOP_STEP_BG';

/**
 * 受験の流れ メイン文字色（タイトル、本文）
 */
export const TOP_STEP_MAIN_COLOR = 'RESULT_BENEFITS_MAIN_COLOR';

/**
 * 受験の流れ サブタイトル文字色
 */
export const TOP_STEP_SUB_TITLE_COLOR = 'RESULT_BENEFITS_SUB_TITLE_COLOR';

// ----------------------------------- //

/**
 * 公式Twitter
 */
export const OFFICIAL_TWITTER = 'OFFICIAL_TWITTER';

/**
 * Twitter表示画像とクリック時遷移先URL
 */
export const TWITTER_IMG = 'TWITTER_IMG';

/**
 * Twitter 共有URL
 */
export const TWITTER_SHARE = 'TWITTER_SHARE';

/**
 * 体験版 Twitter 共有テキスト
 */
export const TWITTER_TEST_EXAM_SHARE_TEXT = 'TWITTER_TEST_EXAM_SHARE_TEXT';

/** 結果 Twitter 共有テキスト */
export const TWITTER_SHARE_RESULT_TEXT = 'TWITTER_SHARE_RESULT_TEXT';

/**
 * 公式Instagram
 */
export const OFFICIAL_INSTAGRAM = 'OFFICIAL_INSTAGRAM';

/**
 * 公式Facebook
 */
export const OFFICIAL_FACEBOOK = 'OFFICIAL_FACEBOOK';

/**
 * 検定ランクのアイコン
 */
export const EXAM_RANK_ICON = 'EXAM_RANK_ICON';

/**
 * グッズ訴求画像
 */
export const GOODS_APPEAL_IMG = 'GOODS_APPEAL_IMG';

/**
 * 問い合わせURL
 */
export const INQUIRY_URL = 'INQUIRY_URL';

/**
 * プライバシーポリシーURL
 */
export const PRIVACY_POLICY_URL = 'PRIVACY_POLICY_URL';

/**
 * 模範解答表示 開始日時
 */
export const SHOW_MODEL_ANSWERS_START = 'SHOW_MODEL_ANSWERS_START';

/** 満点時合格特典非表示 */
export const HIDE_PASS_BENEFIT_WHEN_PERFECT = 'HIDE_PASS_BENEFIT_WHEN_PERFECT';
